<div class="item-page">
  <div class="page-header">
    <p class="page-title">Voeg producten toe</p>
    <span class="active-list-badge">
      <mat-icon class="badge-icon">list_alt</mat-icon>
      {{ activeListName }}
    </span>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">

    <div class="card">
      <mat-form-field appearance="outline">
        <mat-label>Winkel</mat-label>
        <input matInput formControlName="winkel" [matAutocomplete]="shopAuto" (blur)="loadList()">
        <mat-icon matSuffix>store</mat-icon>
        <mat-autocomplete #shopAuto="matAutocomplete">
          @for (shop of filteredShops; track shop) {
            <mat-option [value]="shop">{{ shop }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      @if (item && item.length > 0) {
        <div class="existing-label" (click)="showExisting = !showExisting">
          <mat-icon class="existing-chevron" [class.open]="showExisting">expand_more</mat-icon>
          Al op de lijst ({{ showNumber() }})
        </div>
        @if (showExisting) {
          <div class="existing-items">
            @for (product of item; track $index) {
              <span class="existing-chip">{{ product }}</span>
            }
          </div>
        }
      }
    </div>

    <div class="card products-card" formArrayName="products">
      <div class="products-header">
        <span class="section-label">Producten ({{ products().controls.length }})</span>
        <button type="button" mat-icon-button class="add-btn" (click)="addProduct()">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>

      @for (product of allproducts.controls; track $index; let i = $index) {
        <div class="product-row">
          <mat-form-field appearance="outline" class="product-field">
            <mat-label>Product</mat-label>
            <input [formControlName]="i" matInput [matAutocomplete]="auto"
              (keyup)="my_handler($event, i, product)">
          </mat-form-field>
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of filteredOptions; track $index) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-autocomplete>
          @if (allproducts.controls.length > 1) {
            <button type="button" mat-icon-button class="delete-btn" (click)="removeProduct(i)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          }
        </div>
      }
    </div>

    <button type="submit" mat-flat-button class="submit-btn">
      <mat-icon>add_shopping_cart</mat-icon>
      Voeg toe aan lijst
    </button>

  </form>
</div>
